import { IconType as e } from "./index196.mjs";
import t from "react";
import o from "./index273.mjs";
import c from "./index130.mjs";
import n from "./index133.mjs";
import a from "./index274.mjs";
const E = ({ type: r }) => {
  switch (r) {
    case e.SIZE:
      return /* @__PURE__ */ t.createElement(o, { "data-testid": "icon-size" });
    case e.DOUBLE_BED:
      return /* @__PURE__ */ t.createElement(c, { "data-testid": "icon-double-bed" });
    case e.GUESTS:
      return /* @__PURE__ */ t.createElement(n, { "data-testid": "icon-guests" });
    case e.PROPERTY:
      return /* @__PURE__ */ t.createElement(a, { "data-testid": "icon-property" });
  }
};
export {
  E as Icon
};
